import CurencyCell from "./CurencyCell"
import TextCell from "./TextCell"
import classes from './MultipleRowsCell.module.css'
import CheckCell from "./CheckCell"
import DatePickerCell from "./DatePickerCell"
import StatusCell from "./StatusCell"
import MRQStatusCell from "./MRQStatusCell"
import SurgeryApprovalStatusCell from "./SurgeryApprovalStatusCell"
import SurgeryChargesStatusCell from "./SurgeryChargesStatusCell"
import RecordsUploadContainer from "../../patient/details/recordsUpload/RecordsUploadContainer"
import PracticesUploadItem from "../../patient/details/procodocs/practicesupload/PracticesUploadItem"
import { useSelector } from "react-redux"
import SimpleSelect from "./SimpleSelect"
import { workQFunctions } from "../../../lib/workQ"
import { practicesFunctions } from "../../../lib/practices"
import { checkIfLopIsRequired, formatCurrency, formatDateLocal } from "../../../lib/script"
import {
    getLienStageKeyForWorkQSubItem,
    getWorkQDateColumnLienMessages,
    pickLienCreationErrorsForWorkQ,
} from "../../../lib/lienCreationErrors"
import {
    formatCreatedOnHover,
    getWorkQLienCreatedDate,
} from "../../../lib/lienDisplayDate"
import { useWorkQShell, WorkQHoverHint } from "../context/workQShellContext"
import WorkQDeferredTooltip from "./WorkQDeferredTooltip"


function isSurgeryApprovalStatusEditable(sub_item) {
    return sub_item?.sub_type === "surgery_approval_status"
        || sub_item?.key === "surgery_approval_status_update"
}

function isSurgeryChargesStatusEditable(sub_item) {
    return sub_item?.sub_type === "surgery_charges_status"
        || sub_item?.key === "surgery_surgery_charges_status_update"
}

function isLopColumn(sub_item) {
    return sub_item?.key === "case_practices_lop" || sub_item?.label === "lop"
}

export default function MultipleRowsCell({data, sub_item, caseData, slug}) {



    const userToken = useSelector(state => state.user.token)
    const shell = useWorkQShell()
    if (sub_item.sub_type == 'currency') {
        return <>
        {slug == 'medical-record-q' ? (
            <div className={classes.multiple_rows_cell}>
                {data && data.map((item, index) => {
                    const tipMessage = (
                        <div>
                            <div>{`Charges on last MR Upload: $${formatCurrency(item?.mrq_last_upload_total_charges)}`}</div>
                            <div>{`( $${formatCurrency(item?.mrq_upload_charge_difference)} difference )`}</div>
                        </div>
                    );
                    return (
                    <div className={`${classes.multiple_rows_cell_item} ${workQFunctions.isMedicalRecordQcellChanged(item) ? classes.medical_record_q_cell_changed : ''}`} key={index}>
                        {workQFunctions.isMedicalRecordQcellChanged(item) ? 
                        <>
                            {shell ? (
                                <WorkQHoverHint message={tipMessage} widthAuto fixedWidth={250}>
                                    <CurencyCell text={item[sub_item.label]} test={sub_item} fullHeight={true}/>
                                </WorkQHoverHint>
                            ) : (
                            <WorkQDeferredTooltip mode={'v3'} fixedWidth={250} message={tipMessage}>
                                <CurencyCell text={item[sub_item.label]} test={sub_item} fullHeight={true}/>
                            </WorkQDeferredTooltip>
                            )}
                        </>
                        :
                        <CurencyCell text={item[sub_item.label]} test={sub_item}/>
                        }
                    </div>
                    );
                })}
            </div>
        ) : 
        
        <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={`${classes.multiple_rows_cell_item}`} key={index}>
                    <CurencyCell text={item[sub_item.label]} test={sub_item}/>
                </div>
            ))}
        </div>
        }
        </>
    }

    if (sub_item.sub_type == 'text') {
        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={classes.multiple_rows_cell_item} key={index}>
                    <TextCell text={item[sub_item.label]} group={data} itemKey={sub_item.key} caseData={data} />
                </div>
            ))}
        </div>
    }

    const tableColSubtype = sub_item.sub_type ?? sub_item.subtype
    if (tableColSubtype == 'date' || tableColSubtype == 'datetime') {
        const lienStageKey = getLienStageKeyForWorkQSubItem(sub_item)
        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => {
                const rawDate = item[sub_item.label]
                const createdDate = getWorkQLienCreatedDate(item, sub_item.label)
                const hoverTitle =
                    createdDate &&
                    rawDate &&
                    String(createdDate).slice(0, 10) !== String(rawDate).slice(0, 10)
                        ? formatCreatedOnHover(createdDate, formatDateLocal)
                        : null
                const dateMissing =
                    rawDate == null ||
                    rawDate === "" ||
                    (typeof rawDate === "string" && rawDate.startsWith("0000-00-00"))
                const lienErrors = pickLienCreationErrorsForWorkQ(item, caseData)
                const errorMessages =
                    lienStageKey != null ? getWorkQDateColumnLienMessages(lienErrors, lienStageKey) : []
                const hasLienStageErrors = errorMessages.length > 0
                const tipMessage = hasLienStageErrors ? (
                    <div className={classes.lien_stage_error_tooltip_body}>
                        {errorMessages.map((errorItem, errIdx) => (
                            <div key={`${lienStageKey}-${errIdx}-${errorItem}`}>{errorItem}</div>
                        ))}
                    </div>
                ) : null
                // BodySimpleModalV3 (deferred) reliably shows rich message; WorkQHoverHint is tuned for plain strings.
                const errorIcon = hasLienStageErrors ? (
                    <WorkQDeferredTooltip
                        mode="v3"
                        message={tipMessage}
                        fixedWidth={280}
                        widthAuto
                        disabled={!tipMessage}
                        fillTrigger={false}
                        wrapperClassName={classes.lien_stage_error_tooltip_hit}
                    >
                        <span className={classes.lien_stage_error_icon} aria-hidden>
                            <i className="ti ti-exclamation-circle" />
                        </span>
                    </WorkQDeferredTooltip>
                ) : null
                const dateCell = (
                    <DatePickerCell
                        date={rawDate}
                        item={item}
                        identifier={{ field: sub_item.label }}
                        isDateTime={tableColSubtype == 'datetime'}
                        hideEmptyPlaceholder={hasLienStageErrors && dateMissing}
                        pairDaysAtEnd={true}
                        prefix={hasLienStageErrors && !dateMissing ? errorIcon : null}
                        hoverTitle={hoverTitle}
                    />
                )
                return (
                    <div className={classes.multiple_rows_cell_item} key={index}>
                        {hasLienStageErrors && dateMissing && errorIcon ? (
                            <div className={classes.multiple_rows_date_row_center}>{errorIcon}</div>
                        ) : (
                            dateCell
                        )}
                    </div>
                )
            })}
        </div>
    }

    if (sub_item.sub_type == 'boolean' || sub_item.sub_type == 'checkbox') {
        if (isLopColumn(sub_item)) {
            const lopRequired = checkIfLopIsRequired(caseData?.attorney, caseData)
            return <div className={classes.multiple_rows_cell}>
                {data && data.map((item, index) => (
                    <div className={`${classes.multiple_rows_cell_item} ${classes.multiple_rows_cell_item_flex}`} key={index}>
                        {lopRequired && practicesFunctions.isPracticeRequiresLOP(item.practice_id) ? (
                            <PracticesUploadItem
                                practiceId={item.practice_id}
                                usedFor={'LOP'}
                                uploadDisabled={true}
                                caseAttorneyId={caseData?.attorney?.id}
                                activeCase={caseData}
                            />
                        ) : (
                            <CheckCell checked={item?.has_lop ?? item?.lop} isDisabled={true} />
                        )}
                    </div>
                ))}
            </div>
        }

        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={`${classes.multiple_rows_cell_item} ${classes.multiple_rows_cell_item_flex}`} key={index}>
                    <CheckCell checked={item[sub_item.label]}/>
                </div>
            ))}
        </div>
    }

    if (isSurgeryApprovalStatusEditable(sub_item)) {
        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={classes.multiple_rows_cell_item} key={index}>
                    <SurgeryApprovalStatusCell data={item[sub_item.label]} caseData={caseData} item={item} subItem={sub_item}/>
                </div>
            ))}
        </div>
    }

    if (isSurgeryChargesStatusEditable(sub_item)) {
        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={classes.multiple_rows_cell_item} key={index}>
                    <SurgeryChargesStatusCell data={item[sub_item.label]} caseData={caseData} item={item} subItem={sub_item}/>
                </div>
            ))}
        </div>
    }

    if (sub_item.sub_type == 'status') {
        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={`${classes.multiple_rows_cell_item}`} key={index}>
                    <StatusCell data={item[sub_item.label]} group={data} itemKey={sub_item.key} caseData={data} itemData={item}/>
                </div>
            ))}
        </div>
    }

    if (sub_item.sub_type == 'mrq_status') {
        return <div className={classes.multiple_rows_cell}>
            {data && data.map((item, index) => (
                <div className={classes.multiple_rows_cell_item} key={index}>
                    <MRQStatusCell data={item[sub_item.label]} group={data} itemKey={sub_item.key} caseData={caseData} item={item}/>
                </div>
            ))}
        </div>
    }

    if (sub_item.sub_type == 'simple_select') {
        return <div className={`${classes.multiple_rows_cell} ${classes.record_actions_cell}`}>
            {data && data.map((item, index) => (
                <div className={`${classes.multiple_rows_cell_item} ${classes.multiple_rows_cell_item_flex}`} key={index}>
                    <SimpleSelect data={item[sub_item.label]} group={data} itemKey={sub_item.key} caseData={caseData} item={item} subItem={sub_item}/>
                </div>
            ))}
        </div>
    }

    if (sub_item.sub_type == 'record_actions') {
        return <div className={`${classes.multiple_rows_cell} ${classes.record_actions_cell}`}>
            {data && data.map((item, index) => (
                <div className={`${classes.multiple_rows_cell_item} ${classes.multiple_rows_cell_item_flex}`} key={index}>
                    <RecordsUploadContainer practiceitem={item} managingAttyId={caseData?.attorney?.id} userToken={userToken} activeCase={caseData} docType={item?.mrq_upload?.source == "ProCo" ? 'procodocs' : 'document'} forWorkQ={true}/>
                </div>
            ))}
        </div>
    }

    
}